export function getHotelOfferEncryptedMargin(offer?: App.Offer, packageView?: App.OfferPackageOptionView) {
  if (packageView?.package?.mx || packageView?.package?.roomRate?.mx) return packageView?.package?.mx ?? packageView?.package?.roomRate?.mx
  if (!offer) return undefined

  if (offer.lowestPricePackage?.mx || offer.lowestPricePackage?.roomRate?.mx) return offer.lowestPricePackage?.mx ?? offer.lowestPricePackage?.roomRate?.mx

  return undefined
}
